import { trpc } from '@/shared/api';
export const useInvalidateBankTransfer = () => {
  const utils = trpc.useUtils();
  return (orderId: string) =>
    Promise.all([
      utils.payments.getBankTransfer.invalidate({ orderId }),
      utils.payments.getCheckout.invalidate({ orderId }),
      utils.payments.getBankTransferOption.invalidate({ orderId }),
    ]);
};
